import { SelectInput, required, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { parameterSubsetTypeChoices } from '@/constants/ParameterSubsetTypes.js';

export const ParameterSubsetTypeInput = ({ source, targetSource, nestedSource, parentType }) => {
    const translate = useTranslate();
    const { setValue } = useFormContext();

    return (
        <SelectInput
            source={source}
            label={translate('resources.parameter.fields.subsetType')}
            choices={parameterSubsetTypeChoices(translate, parentType)}
            validate={required(translate('common.validation.required'))}
            onChange={() => {
                setValue(targetSource, [], { shouldDirty: true });
                setValue(nestedSource, [], { shouldDirty: true });
            }}
            fullWidth
        />
    );
};

ParameterSubsetTypeInput.propTypes = {
    source: PropTypes.string.isRequired,
    targetSource: PropTypes.string.isRequired,
    nestedSource: PropTypes.string.isRequired,
    parentType: PropTypes.string,
};
